import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import CreateVideo from "./pages/CreateVideo";
import VideoStudio from "./pages/VideoStudio";
import VideoWizard from "./pages/VideoWizard";
import SelleSuite from "./pages/SelleSuite";
import Templates from "./pages/Templates";
import Broadcast from "./pages/Broadcast";
import Library from "./pages/Library";
import RecordVideo from "./pages/RecordVideo";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import SelleVerify from "./pages/SelleVerify";
import PhotoToVideo from "./pages/PhotoToVideo";
import VidMe from "./pages/VidMe";
import ServicesHub from "./pages/ServicesHub";
import UploadCenter from "./pages/UploadCenter";
import AcquireCustomers from "./pages/AcquireCustomers";
import "@/App.css";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/services" element={<ServicesHub />} />
          <Route path="/create" element={<SelleSuite />} />
          <Route path="/wizard" element={<VideoWizard />} />
          <Route path="/suite" element={<SelleSuite />} />
          <Route path="/upload" element={<UploadCenter />} />
          <Route path="/acquire" element={<AcquireCustomers />} />
          <Route path="/studio/:projectId" element={<VideoStudio />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/broadcast" element={<Broadcast />} />
          <Route path="/broadcast/:projectId" element={<Broadcast />} />
          <Route path="/library" element={<Library />} />
          <Route path="/record" element={<RecordVideo />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/selleverify" element={<SelleVerify />} />
          <Route path="/photo-to-video" element={<PhotoToVideo />} />
          <Route path="/vidme" element={<VidMe />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
